import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-left_3c6dd",
  "use": "arrow-left_3c6dd-usage",
  "viewBox": "0 0 10 16",
  "content": "<symbol viewBox=\"0 0 10 16\" id=\"arrow-left_3c6dd\">\n    <use xlink:href=\"#arrow-left_3c6dd_path0_fill\" transform=\"rotate(45 -6.969 5.743)\" />\n    <use xlink:href=\"#arrow-left_3c6dd_path1_fill\" transform=\"rotate(-45 9.954 3.317)\" />\n    <defs>\n        <path id=\"arrow-left_3c6dd_path0_fill\" fill-rule=\"evenodd\" d=\"M0 0v2h10.973V0H0z\" />\n        <path id=\"arrow-left_3c6dd_path1_fill\" fill-rule=\"evenodd\" d=\"M0 0v2h11.017V0H0z\" />\n    </defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol